import { useEffect, useState } from "react";
import { DeliveryDashboardSettings } from "app/types/deliveryDashboardSettings";
import {
  getCachedDeliveryDashboardSettings,
  subscribeToDeliveryDashboardSettings,
} from "app/utils/deliveryDashboardSettings";

export function useDeliveryDashboardSettings(): DeliveryDashboardSettings | null {
  const [settings, setSettings] = useState<DeliveryDashboardSettings | null>(() =>
    getCachedDeliveryDashboardSettings()
  );

  useEffect(() => subscribeToDeliveryDashboardSettings(setSettings), []);

  return settings;
}
